import React from "react";

export const RedactedContext = React.createContext(false);